<div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
  <div class="tw-flex tw-items-center tw-justify-between tw-mb-5">
    <h2 class="tw-text-base tw-font-semibold tw-text-slate-800">Cambiar Contraseña</h2>
    <button *ngIf="!esOAuth" type="button" (click)="cambiarContra()" class="tw-text-sm tw-font-medium tw-text-blue-600 hover:tw-underline tw-bg-transparent tw-border-0 tw-cursor-pointer">Editar</button>
  </div>

  <!-- Cuenta OAuth: no aplica cambiar contraseña -->
  <div *ngIf="esOAuth" class="tw-flex tw-items-start tw-gap-3 tw-px-4 tw-py-3 tw-rounded-xl tw-bg-slate-50 tw-border tw-border-slate-200 tw-text-sm tw-text-slate-600">
    <svg style="width:18px;height:18px;flex-shrink:0;margin-top:2px;color:#475569;" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
    </svg>
    <div>
      Tu cuenta usa <strong>{{ oauthProviderLabel }}</strong> para iniciar sesión.
      La contraseña se gestiona directamente en {{ oauthProviderLabel }}.
    </div>
  </div>

  <form [formGroup]="formPassword" (ngSubmit)="actualizarContrasenia()" *ngIf="editarContra && !esOAuth">
    <div class="tw-max-w-md tw-mx-auto tw-flex tw-flex-col tw-gap-4">

      <div>
        <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Nueva Contraseña</label>
        <div class="tw-relative">
          <input [type]="showNuevaPass ? 'text' : 'password'" formControlName="passNueva"
                 placeholder="••••••••" minlength="8" required
                 class="tw-w-full tw-px-4 tw-py-2.5 tw-pr-10 tw-rounded-xl tw-border tw-border-slate-200
                        tw-text-slate-900 tw-text-sm tw-outline-none tw-bg-white
                        focus:tw-ring-2 focus:tw-ring-blue-500/30 focus:tw-border-blue-500
                        tw-transition tw-duration-150">
          <button type="button" (click)="showNuevaPass = !showNuevaPass" tabindex="-1"
                  class="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer">
            <svg *ngIf="!showNuevaPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"/>
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <svg *ngIf="showNuevaPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
            </svg>
          </button>
        </div>
        <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formPassword.controls.passNueva.errors && mostrarMensaje">
          <div *ngIf="formPassword.controls.passNueva.errors.required">La contraseña nueva es requerida.</div>
          <div *ngIf="formPassword.controls.passNueva.errors.minlength">La contraseña nueva debe contener al menos 8 carácteres.</div>
        </div>
      </div>

      <div>
        <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Confirmar Contraseña</label>
        <div class="tw-relative">
          <input [type]="showConfirmPass ? 'text' : 'password'" formControlName="passConfim"
                 placeholder="••••••••" minlength="8" required
                 class="tw-w-full tw-px-4 tw-py-2.5 tw-pr-10 tw-rounded-xl tw-border tw-border-slate-200
                        tw-text-slate-900 tw-text-sm tw-outline-none tw-bg-white
                        focus:tw-ring-2 focus:tw-ring-blue-500/30 focus:tw-border-blue-500
                        tw-transition tw-duration-150">
          <button type="button" (click)="showConfirmPass = !showConfirmPass" tabindex="-1"
                  class="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer">
            <svg *ngIf="!showConfirmPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"/>
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <svg *ngIf="showConfirmPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
            </svg>
          </button>
        </div>
        <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formPassword.controls.passConfim.errors && mostrarMensaje">
          <div *ngIf="formPassword.controls.passConfim.errors.required">La contraseña de confirmación es requerida.</div>
          <div *ngIf="formPassword.controls.passConfim.errors.minlength">La contraseña de confirmación debe contener al menos 8 carácteres.</div>
        </div>
      </div>

      <div *ngIf="mensajeExito">
        <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-emerald-50 tw-border tw-border-emerald-200 tw-text-sm tw-text-emerald-700">{{mensajeExito}}</div>
      </div>
      <div *ngIf="mensajeError">
        <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600">{{mensajeError}}</div>
      </div>

      <button type="submit"
        class="tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-transition"
        style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
        Actualizar
      </button>

    </div>
  </form>
</div>
